import { HttpMethod } from '@nu-art/thunderstorm-shared';
export const ApiDef_Analytics = (baseUrl) => ({
    _v1: {
        sendEvents: { baseUrl, method: HttpMethod.POST, path: '/v1/analytics/send-events' },
        updateUser: { baseUrl, method: HttpMethod.POST, path: '/v1/analytics/update-user' },
        updateLexicon: { baseUrl, method: HttpMethod.POST, path: '/v1/analytics/update-lexicon' },
    }
});
//# sourceMappingURL=api-def.js.map